<!-- //
表单组件-表单块组件（包含多个表单元素，左到右分别一级，二级/可能输入,三级/可能包含输入，四级/可能包含输入)
@auth xuyd
@date 2026-01-05
//-->
<template>
  <div class="form-block">

  </div>
</template>

<script>


export default {
  name: 'FormBlock',
  data() {
    return {
      formBlockList:[],
    }
  },
  props: {
    /**
     * 数据显示：
     *
     * --|----|-------------------
     *   |    |      | 1.1.1.1
     *   |    |1.1.1 | 1.1.1.2
     *   |    |      | 1.1.1.3
     *   |    |------|--------------
     *   |1.1 |      | 1.1.2.1
     *   |    |      | 1.1.2.2
     * 1 |    | 1.1.2| 1.1.2.3
     *   |    |      | 1.1.2.4
     *   |    |      | 1.1.2.5
     *   |----|-------------------
     *   |    |      | 1.2.1.1
     *   |1.2 |1.2.1 | 1.2.1.2
     *   |    |      | 1.2.1.3
     * --|----|-------------------
     *   |    |      | 2.1.1.1
     * 2 |2.1 |2.1.1 | 2.1.1.2
     *   |    |      | 2.1.1.3
     * --|----|-------------------
     *
     * 元数据定义：
     *
     * 1.显示部分：
     * inputType=[label(空), input, datePicker, dateTimePicker, select, checkbox, radio ]
     * select时候需要定义：dictType eg:YES_OR_NO
     * label:可以也可以定义dictType，即文本值直接转义显示
     *
     * 2.控制部分
     * 下拉选择不同的内容，控制当前部分字段显示/隐藏（隐藏的内容要清空值，防止误传到服务端）
     * 下拉选择不同的内容，控制其他form-block组件显示
     *
     * 3.组件间通信:
     * 当前form-block表单块，选择不同的内容，其他formBlock内容会动态显示/隐藏一些字段项（隐藏的内容清空值）
     *
     * 4.子组件部分：
     * 变量名的input控件：未来手套房首付超过${minAmount}万元，不超过${maxAmount}万元。
     *
     */
    formMetaData: [Array],
  },

  methods: {
  }
}
</script>

<style lang="less" scoped>
.block {
  background-color: #444444;
  color: #fedb8b;
  font-size: 12px;
  width: 50px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
</style>
